import React from "react";
import {Avatar} from "@mui/material";

import CentricTheme from "../../../../themes/CentricTheme";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

import {chrColours} from "../../../../constants/Colour";


const MessageAvatar = React.forwardRef(function NoteAvatar(props, ref) {
    const { initial, disabled, ...rest } = props
    return (
        <div {...rest} ref={ref}>
            <IconAvatar initial={initial} disabled={disabled} />
        </div>
    );
});

const IconAvatar = ({initial = null, disabled = false}) => {

    const opacity = disabled ? 0.38 : 1;
    const validInitial = new RegExp('^[a-zA-Z0-9]$');

    let icon = '';
    let backgroundColor = CentricTheme.palette.primary.main;

    if (validInitial.test(initial)) {

        initial = initial.toUpperCase();
        icon = initial;
        backgroundColor = chrColours.get(initial);

    } else {
        icon = <EmailOutlinedIcon title="Message" />;
    }

    return (
        <Avatar
            aria-label="Message"
            style={{ backgroundColor: backgroundColor, color: '#FFF', opacity: opacity}}
            sx={{width: 52, height: 52, marginRight: '4px'}}
        >
            {icon}
        </Avatar>
    );

};


export default MessageAvatar;
